import React from "react";
import { Routes, Route } from "react-router-dom";
import HeaderAgent from "../Components/Agent/headerAgent";
import ListAgent from "../Components/Agent/listAgent";
import ListTimeSlot from "../Components/Agent/listTimeSlot";
// import AddTeamMember from "../Components/Team Members/addTeamMember";
// import EditTeamMember from "../Components/Team Members/EditTeamMember";
import ViewAgents from "../Components/Agent/viewAgent";

const AgentRoutes = () => {
  return (
    <Routes>
      <Route path="/agent" element={<HeaderAgent></HeaderAgent>}></Route>
      <Route path="/agent_list" element={<ListAgent></ListAgent>}></Route>
      <Route path="/time_slot" element={<ListTimeSlot></ListTimeSlot>}></Route>
      {/* <Route path="/agent/add" element={<AddTeamMember></AddTeamMember>}></Route>
      <Route
        path="/agent/edit/:id"
        element={<EditTeamMember></EditTeamMember>}
      ></Route> */}
      <Route path="/agent/view/:id" element={<ViewAgents />}></Route>
    </Routes>
  );
};

export default AgentRoutes;
